import { render, staticRenderFns } from "./FightSummary.vue?vue&type=template&id=33bde418&"
import script from "./FightSummary.vue?vue&type=script&lang=js&"
export * from "./FightSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports